export const decodeHtmlEntities = (str: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
};

/**
 * Extract error message from Axios error or any other error
 * @param error - The error object
 * @param fallbackMessage - Optional fallback message if no error message is found
 * @returns The extracted error message
 */
export function extractErrorMessage(
    error: unknown,
    fallbackMessage = 'An unknown error occurred',
): string {
    if (error instanceof Error) {
        return error.message;
    }

    // Handle Axios errors
    if (typeof error === 'object' && error !== null && 'isAxiosError' in error) {
        const axiosError = error as any;
        return (
            axiosError.response?.data?.message ||
            axiosError.response?.data?.error ||
            axiosError.message ||
            fallbackMessage
        );
    }

    // Handle string errors
    if (typeof error === 'string') {
        return error;
    }

    return fallbackMessage;
}

export const formatCurrency = (value: number, decimals: number = 2) => {
    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(value);
};

export const formatDate = (value: string) => {
    if (!value) return '';

    return new Date(value).toLocaleDateString('da-DK', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
};

export const formatDateTime = (value: string) => {
    if (!value) return '';

    const d = new Date(value);
    if (isNaN(d.getTime())) return '';

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear());
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export function popupCenterDual(url: string, title: string, w: number, h: number) {
    // Fixes dual-screen position Most browsers Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : (screen as any).left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : (screen as any).top;
    var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : screen.width;
    var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(
        url,
        title,
        'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left,
    );

    // Puts focus on the newWindow
    if (newWindow) {
        newWindow.focus();
    }
}

export function getByPath(obj: any, path: string) {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function setByPath(obj: any, path: string, value: any) {
    const keys = path.split('.');
    let curr = obj;
    keys.forEach((key, index) => {
        if (index === keys.length - 1) {
            curr[key] = value;
        } else {
            if (!curr[key] || typeof curr[key] !== 'object') {
                curr[key] = {};
            }
            curr = curr[key];
        }
    });
}

export function handleQueryRetry(
    failureCount: number,
    error: any,
    maxRetries = 2,
    errorMessage = 'You are not authorized to access this page',
): boolean {
    if (error?.response?.status === 403) {
        // Import dynamically to avoid circular dependencies
        import('vue-sonner').then(({ toast }) => {
            toast.error(errorMessage);
        });
        return false;
    }
    return failureCount < maxRetries;
}
